import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import {
  buildYhcAreaCodeWithNameSelections,
  formatYhcAreaCodeWithName,
} from '../constants/area'

/**
 * 郵便番号別マスタ
 * - マスタ取込で投入される読み取り専用マスタ（管理画面からの CRUD 不可）
 */
export const yhc_by_zipcodes: ModelDef = {
  tableName: 'yhc_by_zipcodes',
  tableLabel: '郵便番号別マスタ',
  primaryKeyColType: 'STRING',
  creatable: false,
  updatable: false,
  deletable: false,
  columns: {
    id: {
      type: 'STRING',
      label: 'version-zip',
      replicable: true,
    },
    version: {
      type: 'STRING',
      label: 'バージョン',
      replicable: true,
      selections: () => $core.$yhcFetchVersions(),
    },
    zip: {
      type: 'STRING',
      label: '郵便番号',
      replicable: true,
    },
    prefCode: {
      type: 'STRING',
      label: '都道府県コード',
      replicable: true,
      selections: () => buildYhcAreaCodeWithNameSelections(),
      customLabel: (value) => formatYhcAreaCodeWithName(value),
    },
    city: {
      type: 'STRING',
      label: '市区郡',
      replicable: true,
    },
    town: {
      type: 'STRING',
      label: '町村番地',
      replicable: true,
    },
    kazaiStoreCode: {
      type: 'STRING',
      label: '家財担当店',
      replicable: true,
    },
    kazaiTypeCode: {
      type: 'STRING',
      label: '家財仕分CD',
      replicable: true,
    },
    deliveryAreaFlag: {
      type: 'STRING',
      label: '配達エリアフラグ',
      replicable: true,
      afterComponent: `<span class="small text-secondary">
<code>1</code>:YHC提供エリア<br/>
<code>0</code>:YTC提供エリア<br/>
<code>2</code>:YTC提供 特殊家財配達不能エリア(F&Gランク 家財は対応不可)<br/>
<code>3</code>:家財配達不能エリア(すべて対応不可)
</span>`,
    },
    estimateArea: {
      type: 'STRING',
      label: '見積エリア',
      replicable: true,
    },
    timeBand: {
      type: 'STRING',
      label: '時間帯区分',
      replicable: true,
      afterComponent: `<span class="small text-secondary">
<code>0</code>: ４区分 (午前, 12-15時, 15-18時, 18-21時)<br/>
<code>1</code>: ３区分[無料]  (午前, 12-18時, 18-21時)<br/>
<code>2</code>: ３区分[有料]<br/>
<code>3</code>: 指定不可<br/>
<code>4</code>: ４区分 (8-12時, 12-16時, 16-19時, 18-21時)<br/>
<code>5</code>: 指定不可（2027-01-01〜 / JIT可）<br/>
Excel の <code>0</code> / <code>3</code> は、適用開始 2027-01-01 以降の版では取込時に <code>4</code> / <code>5</code> として保存されます
  </span>`,
    },
    sameDayDeliveryEnabled: {
      type: 'BOOLEAN',
      label: '当日自発着可能フラグ',
      replicable: true,
    },
    regularWorkingDay: {
      type: 'STRING',
      label: '営業日パターン',
      adminComment: `営業日パターンマスタのパターン名が設定される
該当の営業日パターンマスタと突き合わせるにはこのパターン名と有効期間でフィルタリングする`,
      editable: false,
      bulkEditable: false,
    },
    isRemoteIsland: {
      type: 'BOOLEAN',
      label: '離島フラグ',
    },
    additionalLeadTimeDaysFrom: {
      type: 'NUMBER',
      label: 'リードタイム加算日数_発地',
    },
    additionalLeadTimeDaysTo: {
      type: 'NUMBER',
      label: 'リードタイム加算日数_着地',
    },
  },
}
